export const grantorLicenseValidation = (values) => {
  const errors = {};

  if (!values.drivingLicenseFront) {
    errors.drivingLicenseFront = "*Driver's License Front is required";
  }
  if (!values.drivingLicenseBack) {
    errors.drivingLicenseBack = "*Driver's License Back is required";
  }

  return errors;
};

export const revokePreviewUrl = (previewUrl) => {
  if (previewUrl) {
    URL.revokeObjectURL(previewUrl);
  }
};

export const createFilePreviewUrl = (file) => {
  if (file?.type?.startsWith("image/")) {
    return URL.createObjectURL(file);
  }
  return null;
};
